import {app} from '../app';
import {IUniqueIdService} from '../services/UniqueIdService';
import * as SimpleMDE from '../../../../node_modules/simplemde/dist/simplemde.min.js';

export class SimpleMdeComponent {

    private scope:ng.IScope;
    private uniqueIdService:IUniqueIdService;
    private simplemde:any;

    id:string;
    change:(arg:{value:string}) => void;
    show:boolean;
    maxCharacters:number;
    initialValue:string;
    watcher = false;

    static $inject = ['$scope', 'UniqueIdService'];

    constructor($scope:ng.IScope, UniqueIdService:IUniqueIdService) {
        this.scope           = $scope;
        this.uniqueIdService = UniqueIdService;
    }

    $onInit() {
        if (!this.watcher) {
            this.scope.$watch('show', () => this.$onInit());
            this.watcher = true;
        }

        this.id = this.uniqueIdService.getUniqueId('simple-mde');

        if (this.show && !this.simplemde) {
            this.simplemde = new SimpleMDE({
                element     : angular.element(this.id)[0],
                initialValue: this.initialValue
            });

            // handle max characters
            this.simplemde.codemirror.on('beforeChange', (cm, change) => {
                if (this.maxCharacters && change.update) {
                    let str   = change.text.join('\n'),
                        delta = str.length - (cm.indexFromPos(change.to) - cm.indexFromPos(change.from));

                    if (delta <= 0) {
                        return true;
                    }

                    delta = cm.getValue().length + delta - this.maxCharacters;
                    if (delta > 0) {
                        str = str.substr(0, str.length - delta);
                        change.update(change.from, change.to, str.split("\n"));
                    }
                }

                return true;
            });

            this.simplemde.codemirror.on('change', () => {
                this.change({
                    value: this.simplemde.value()
                });
            });
        }

        if (!this.show && this.simplemde) {
            this.simplemde.toTextArea();
            this.simplemde = null;
        }

    }

}

app.component('simpleMde', {
    templateUrl : 'templates/components/simpleMde.html',
    controller  : SimpleMdeComponent,
    controllerAs: 'simpleMde',
    transclude  : true,
    bindings    : {
        change       : '&',
        show         : '=',
        initialValue : '=',
        maxCharacters: '='
    }
});